import React from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import { Button } from "src/common/components/Button";
import { Input } from "src/common/components/Input";

import "./PasswordInput.css";

type PasswordInputProps = Omit<
	React.ComponentProps<typeof Input>,
	"type" | "decorator"
>;

export const PasswordInput: React.FunctionComponent<
	PasswordInputProps
> = props => {
	const [inputType, setInputType] = React.useState<"password" | "text">(
		"password"
	);
	const onToggleType = React.useCallback(() => {
		setInputType(inputType =>
			inputType === "password" ? "text" : "password"
		);
	}, []);
	return (
		<Input
			{...props}
			className="input--password"
			type={inputType}
			decorator={
				<Button variant="icon" type="button" onClick={onToggleType}>
					{inputType === "password" ? <FaEye /> : <FaEyeSlash />}
				</Button>
			}
		/>
	);
};
